export default __webpack_public_path__ + "static/media/Raider's Armbands of World's Edge.5cfd893d.jpg";